// extracted by mini-css-extract-plugin
export default {"overlay":"VA-z","bodyOpen":"WA-z","content":"XA-z","header":"YA-z","close":"ZA-z","closeNoHeading":"_A-z"};